import createContainer from 'constate';

const RouterContext = createContainer(
  (router) => router,
  (props) => [props.router.query, props.router.deviceType]
);

export { RouterContext };
